export const MAX_FOCUS_SYMBOLS = 20;
export const MAX_COMPARE_SYMBOLS = 5;
